export default "__VITE_ASSET__HJQZUrjC__"